let language = {
    STORE_PRODUCT_SETTING_FIX_PRICE_HEAD_PRICE_STRATEGY: "定价策略",
    STORE_PRODUCT_SETTING_FIX_PRICE_HEAD_WHITELABLE_PRICE: "标价",
    STORE_PRODUCT_SETTING_FIX_PRICE_HEAD_REVENUE: "收入",
    STORE_PRODUCT_SETTING_FIX_PRICE_HEAD_RETAIL_PRICE: "零售价",
    STORE_PRODUCT_SETTING_FIX_PRICE_TYPE: "固定价格",
    STORE_PRODUCT_SETTING_FIX_PRICE_SET_REVENUE: "设置利润",
    STORE_PRODUCT_SETTING_FIX_PRICE_REVENUE_CHANGE_TO: "变更为",
    STORE_PRODUCT_SETTING_FIX_PRICE_REVENUE_INCREASE_BY: "增加",
    STORE_PRODUCT_SETTING_FIX_PRICE_REVENUE_DECREASE_BY: "减少",
};

export { language }
